(function () {
  var INDEX_GLOBAL = 'ARTLINES_VEHICLE_FINDER_INDEX';
  var PRODUCT_TYPE_ORDER = ['Sticker', 'Mug', 'Poster', 'T-shirt', 'Hoodie'];
  var CUSTOM_FALLBACK_HANDLE = 'custom-t-shirt';
  var ANY_DESIGN_FALLBACKS = [
    { handle: 'artlines-sticker', type: 'Sticker' },
    { handle: 'artlines-mug', type: 'Mug' },
    { handle: 'artlines-poster', type: 'Poster' },
    { handle: 'artlines-hoodie', type: 'Hoodie' },
  ];
  var productCache = {};
  var indexPromise = null;

  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function handleList(value) {
    return Array.from(new Set(String(value || '').split(',').map(function (handle) {
      return normalize(handle);
    }).filter(Boolean)));
  }

  function productTypeRank(product) {
    var index = PRODUCT_TYPE_ORDER.indexOf(product.type);
    return index === -1 ? PRODUCT_TYPE_ORDER.length : index;
  }

  function productSort(a, b) {
    return productTypeRank(a) - productTypeRank(b) || a.title.localeCompare(b.title);
  }

  function typeList(value) {
    return Array.from(new Set(String(value || '').split(',').map(function (type) {
      return normalize(type);
    }).filter(Boolean)));
  }

  function productMatchesDesiredTypes(product, desiredTypes) {
    return !desiredTypes.length || desiredTypes.indexOf(normalize(product.type)) !== -1;
  }

  function productUrl(handle) {
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    return root + 'products/' + encodeURIComponent(handle);
  }

  function productJsonUrl(handle) {
    return productUrl(handle) + '.js';
  }

  function sourceHandle(element) {
    return handleList(element.dataset.sourceHandles || element.dataset.currentHandle)[0] || '';
  }

  function surfaceName(element) {
    return element.dataset.surface || (element.closest('cart-drawer') ? 'cart_drawer' : 'product_page');
  }

  function loadIndex(src) {
    if (window[INDEX_GLOBAL] && Array.isArray(window[INDEX_GLOBAL].vehicles)) {
      return Promise.resolve(window[INDEX_GLOBAL]);
    }

    if (indexPromise) return indexPromise;
    if (!src) return Promise.reject(new Error('Missing recommendation index source'));

    indexPromise = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = src;
      script.defer = true;
      script.onload = function () {
        if (window[INDEX_GLOBAL] && Array.isArray(window[INDEX_GLOBAL].vehicles)) {
          resolve(window[INDEX_GLOBAL]);
        } else {
          reject(new Error('Recommendation index did not initialize'));
        }
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });

    return indexPromise;
  }

  function fetchProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (productCache[handle]) return productCache[handle];

    productCache[handle] = fetch(productJsonUrl(handle))
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.json();
      })
      .catch(function () {
        return null;
      });

    return productCache[handle];
  }

  function makeProductRecord(product, vehicle, reason) {
    return {
      kind: 'product',
      reason: reason,
      make: vehicle ? vehicle.make : '',
      modelFamily: vehicle ? vehicle.modelFamily : '',
      vehicleLabel: vehicle ? vehicle.label : '',
      title: product.title,
      handle: normalize(product.handle),
      url: product.url || productUrl(product.handle),
      type: product.type || '',
      image: product.image || '',
      hoverImage: product.hoverImage || '',
      price: product.price || '',
      multiVersion: Boolean(product.multiVersion),
    };
  }

  function addCandidate(state, product, vehicle, reason) {
    var handle = normalize(product && product.handle);
    if (!handle || state.excluded.indexOf(handle) !== -1 || state.seen.indexOf(handle) !== -1) return;
    state.seen.push(handle);
    state.results.push(makeProductRecord(product, vehicle, reason));
  }

  function productTypesForVehicles(vehicles) {
    return Array.from(new Set(vehicles.reduce(function (types, vehicle) {
      (vehicle.products || []).forEach(function (product) {
        if (product.type) types.push(product.type);
      });
      return types;
    }, [])));
  }

  function addVehicleProducts(state, vehicles, reason) {
    var candidates = vehicles.reduce(function (products, vehicle) {
      var sorted = (vehicle.products || []).slice().sort(productSort);
      sorted.forEach(function (product) {
        products.push({ product: product, vehicle: vehicle });
      });
      return products;
    }, []);

    candidates.forEach(function (candidate) {
      if (state.results.length >= state.limit) return;
      addCandidate(state, candidate.product, candidate.vehicle, reason);
    });
  }

  function findSourceVehicles(vehicles, sourceHandles) {
    return vehicles.filter(function (vehicle) {
      return (vehicle.products || []).some(function (product) {
        return sourceHandles.indexOf(normalize(product.handle)) !== -1;
      });
    });
  }

  function fallbackRecord(handle) {
    return fetchProduct(handle).then(function (product) {
      if (!product) return null;
      var image = product.featured_image || (product.images || [])[0] || '';
      var variant = (product.variants || []).find(function (item) { return item.available; }) || (product.variants || [])[0];
      return {
        kind: 'product',
        reason: 'fallback',
        make: '',
        modelFamily: '',
        vehicleLabel: '',
        title: product.title,
        handle: normalize(product.handle || handle),
        url: product.url || productUrl(handle),
        type: product.type || '',
        image: image,
        hoverImage: '',
        price: variant ? String(Number(variant.price) / 100) : '',
        multiVersion: (product.variants || []).length > 1,
      };
    });
  }

  function formatPrice(price) {
    if (price === '' || price === null || price === undefined) return '';
    var amount = Number(price);
    if (!Number.isFinite(amount)) return '';
    return new Intl.NumberFormat(Shopify.locale || 'en', {
      style: 'currency',
      currency: Shopify.currency && Shopify.currency.active ? Shopify.currency.active : 'USD',
    }).format(amount);
  }

  function recommendationImageUrl(src) {
    if (!src) return '';
    var separator = src.indexOf('?') === -1 ? '?' : '&';
    return src + separator + 'width=360&height=360&crop=center';
  }

  function attributionPayload(element, product) {
    return {
      surface: surfaceName(element),
      source: sourceHandle(element),
      product: product.handle,
      reason: product.reason || '',
      vehicle: product.vehicleLabel || '',
    };
  }

  function attributionProperties(payload) {
    return {
      _al_rec_surface: payload.surface,
      _al_rec_source: payload.source,
      _al_rec_product: payload.product,
      _al_rec_reason: payload.reason,
      _al_rec_vehicle: payload.vehicle,
    };
  }

  function bundleProperties(element) {
    var type = element.dataset.bundleType || '';
    var tier = element.dataset.bundleTier || '';
    var source = element.dataset.bundleSource || surfaceName(element);
    var vehicle = element.dataset.bundleVehicle || '';

    if (!type && !tier && !source && !vehicle) return {};

    return {
      _al_bundle_source: source,
      _al_bundle_type: type,
      _al_bundle_tier: tier,
      _al_bundle_vehicle: vehicle,
    };
  }

  function attributionUrl(url, payload) {
    var destination = new URL(url, window.location.origin);
    destination.searchParams.set('al_rec_surface', payload.surface);
    destination.searchParams.set('al_rec_source', payload.source);
    destination.searchParams.set('al_rec_product', payload.product);
    destination.searchParams.set('al_rec_reason', payload.reason);
    if (payload.vehicle) destination.searchParams.set('al_rec_vehicle', payload.vehicle);
    return destination.pathname + destination.search + destination.hash;
  }

  function pushAnalytics(eventName, payload, items) {
    if (!Array.isArray(window.dataLayer)) return;
    window.dataLayer.push({
      event: eventName,
      al_rec_surface: payload.surface,
      al_rec_source: payload.source,
      al_rec_product: payload.product,
      al_rec_reason: payload.reason,
      al_rec_vehicle: payload.vehicle,
      al_rec_items: items || undefined,
    });
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  class ArtlinesRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded === 'true') return;
      this.dataset.loaded = 'true';
      this.render();
    }

    async render() {
      var sourceHandles = handleList(this.dataset.sourceHandles || this.dataset.currentHandle);
      var excluded = handleList(this.dataset.excludeHandles || this.dataset.currentHandle);
      var grid = this.querySelector('[data-artlines-recommendations-grid]');
      var limit = Number(this.dataset.limit || 4);
      var fallbackHandles = handleList(this.dataset.fallbackHandles);
      var desiredTypes = typeList(this.dataset.desiredTypes);

      if (!grid || !sourceHandles.length || !limit) {
        this.hidden = true;
        return;
      }

      try {
        var index = await loadIndex(this.dataset.indexSrc);
        var recommendations = await this.buildRecommendations(index.vehicles, sourceHandles, excluded, fallbackHandles, limit, desiredTypes);

        if (!recommendations.length) {
          this.hidden = true;
          return;
        }

        grid.innerHTML = recommendations.map(this.renderCard.bind(this)).join('');
        this.hydrateActions(recommendations);
        this.bindAddButtons();
        pushAnalytics('al_recommendations_view', {
          surface: surfaceName(this),
          source: sourceHandle(this),
          product: '',
          reason: '',
          vehicle: '',
        }, recommendations.map(function (product) {
          return {
            handle: product.handle,
            reason: product.reason,
            vehicle: product.vehicleLabel,
            type: product.type,
          };
        }));
      } catch (error) {
        this.hidden = true;
      }
    }

    async buildRecommendations(vehicles, sourceHandles, excluded, fallbackHandles, limit, desiredTypes) {
      var state = {
        excluded: excluded,
        limit: limit,
        seen: [],
        results: [],
      };
      var sourceVehicles = findSourceVehicles(vehicles, sourceHandles);
      var exactProductTypes = productTypesForVehicles(sourceVehicles);
      // Ranking intentionally mirrors the vehicle finder's hierarchy:
      // exact vehicle group only, with type-aware Any Design products filling open slots.
      // Nearby model-family or same-make matching is intentionally avoided because
      // Artlines customers are shopping for a very specific vehicle.
      addVehicleProducts(
        state,
        sourceVehicles.map(function (vehicle) {
          return {
            ...vehicle,
            products: (vehicle.products || []).filter(function (product) {
              return productMatchesDesiredTypes(product, desiredTypes);
            }),
          };
        }),
        'exact_vehicle'
      );

      if (state.results.length < limit) {
        var fallbackPool = fallbackHandles.length
          ? fallbackHandles.map(function (handle) { return { handle: handle, type: '' }; })
          : ANY_DESIGN_FALLBACKS.filter(function (fallback) {
            return exactProductTypes.indexOf(fallback.type) === -1 && productMatchesDesiredTypes(fallback, desiredTypes);
          });

        if (!sourceVehicles.length) fallbackPool.unshift({ handle: CUSTOM_FALLBACK_HANDLE, type: '' });

        for (var i = 0; i < fallbackPool.length && state.results.length < limit; i += 1) {
          var fallback = await fallbackRecord(fallbackPool[i].handle);
          if (fallback && !productMatchesDesiredTypes(fallback, desiredTypes)) fallback = null;
          if (fallback) addCandidate(state, fallback, null, 'fallback');
        }
      }

      return state.results.slice(0, limit);
    }

    renderCard(product) {
      var attribution = attributionPayload(this, product);
      var url = attributionUrl(product.url, attribution);
      var imageUrl = recommendationImageUrl(product.image);
      var image = product.image
        ? '<span class="artlines-recommendations__media"><img class="artlines-recommendations__image" src="' + escapeHtml(imageUrl) + '" alt="' + escapeHtml(product.title) + '" loading="lazy" width="180" height="180"></span>'
        : '<div class="artlines-recommendations__image"></div>';
      var meta = [product.type, formatPrice(product.price)].filter(Boolean).join(' · ');

      return [
        '<article class="artlines-recommendations__item" data-recommendation-handle="' + escapeHtml(product.handle) + '" data-recommendation-attribution="' + escapeHtml(JSON.stringify(attribution)) + '">',
          '<a class="artlines-recommendations__card" href="' + escapeHtml(url) + '" data-recommendation-click>',
            image,
            '<div class="artlines-recommendations__content">',
              '<p class="artlines-recommendations__title">' + escapeHtml(product.title) + '</p>',
              meta ? '<p class="artlines-recommendations__meta">' + escapeHtml(meta) + '</p>' : '',
            '</div>',
          '</a>',
          '<div class="artlines-recommendations__actions" data-recommendation-actions></div>',
        '</article>',
      ].join('');
    }

    hydrateActions(recommendations) {
      recommendations.forEach(function (recommendation) {
        fetchProduct(recommendation.handle).then(function (product) {
          var escapedHandle = window.CSS && CSS.escape ? CSS.escape(recommendation.handle) : recommendation.handle.replace(/"/g, '\\"');
          var item = this.querySelector('[data-recommendation-handle="' + escapedHandle + '"]');
          var actions = item && item.querySelector('[data-recommendation-actions]');
          if (!actions || !product) return;

          var variants = product.variants || [];
          var availableVariants = variants.filter(function (variant) { return variant.available; });
          if (availableVariants.length === 1 && variants.length === 1) {
            actions.innerHTML = '<button type="button" class="artlines-recommendations__button button" data-recommendation-add="' + availableVariants[0].id + '">Add</button>';
          } else {
            var attribution = attributionPayload(this, recommendation);
            actions.innerHTML = '<a class="artlines-recommendations__button button" href="' + escapeHtml(attributionUrl(product.url || productUrl(recommendation.handle), attribution)) + '" data-recommendation-click>Choose options</a>';
          }
        }.bind(this));
      }.bind(this));
    }

    bindAddButtons() {
      this.addEventListener('click', async function (event) {
        var button = event.target.closest('[data-recommendation-add]');
        var clickedRecommendation = event.target.closest('[data-recommendation-click]');
        var item = event.target.closest('[data-recommendation-attribution]');
        var attribution = item ? JSON.parse(item.dataset.recommendationAttribution || '{}') : {};

        if (clickedRecommendation && attribution.product) {
          pushAnalytics('al_recommendation_click', attribution);
        }

        if (!button) return;

        button.setAttribute('aria-disabled', true);
        button.classList.add('loading');

        var cartDrawer = this.closest('cart-drawer') || document.querySelector('cart-drawer');
        var sections = cartDrawer ? cartDrawer.getSectionsToRender().map(function (section) { return section.id; }) : ['cart-icon-bubble'];
        var body = JSON.stringify({
          id: Number(button.dataset.recommendationAdd),
          quantity: 1,
          properties: {
            ...attributionProperties(attribution),
            ...bundleProperties(this),
          },
          sections: sections,
          sections_url: window.location.pathname,
        });

        try {
          var response = await fetch(routes.cart_add_url + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
            body: body,
          });
          var parsedState = await response.json();
          pushAnalytics('al_recommendation_add_to_cart', attribution);

          if (cartDrawer && parsedState.sections) {
            cartDrawer.renderContents(parsedState);
          } else if (parsedState.sections && parsedState.sections['cart-icon-bubble']) {
            var cartIcon = document.getElementById('cart-icon-bubble');
            if (cartIcon) cartIcon.innerHTML = new DOMParser().parseFromString(parsedState.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section').innerHTML;
          }
        } catch (error) {
          button.removeAttribute('aria-disabled');
          button.classList.remove('loading');
        }
      }.bind(this));
    }
  }

  if (!customElements.get('artlines-recommendations')) {
    customElements.define('artlines-recommendations', ArtlinesRecommendations);
  }
})();
